import { render, staticRenderFns } from "./Noc.vue?vue&type=template&id=34d97f99"
import script from "./Noc.vue?vue&type=script&lang=js"
export * from "./Noc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports